export default __webpack_public_path__ + "static/media/apex-graphics-desktop.a34271d4.jpg";